<template>
  <div v-if="getSubscription && getPlans && getQuotas">
    <v-list-item class="px-3" @click="$router.push({ name: 'subscriptions' })">
      <v-list-item-content class="pb-0">
        <v-list-item-title class="mb-0"> Plan </v-list-item-title>
        <v-list-item-subtitle class="pb-1 mt-0">
          {{ getPlans[getSubscription.type].name }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action v-if="!show && getSubscription.type !== 'escala'" class="mt-3">
        <v-btn x-small rounded color="accent" class="black--text" @click.stop="dialogModalPlans = true">
          Actualizar plan
        </v-btn>
      </v-list-item-action>
    </v-list-item>

    <v-list-item class="px-3" :style="{ 'min-height': '20px' }" @click="$router.push({ name: 'subscriptions' })">
      <v-list-item-content class="py-0">
        <v-progress-linear
          v-model="getPercentage"
          :color="getPercentage >= 90 ? 'red' : 'accent accent-4'"
          :style="{ 'max-height': '10px' }"
        />
        <div v-if="!show" class="d-flex justify-space-between">
          <span class="text-caption text-secondary">0</span>
          <span class="text-caption">{{ getQuotas.orders_amount_max }} {{ getSubscription.currency.code }}</span>
        </div>
      </v-list-item-content>
    </v-list-item>

    <ModalPlans v-if="dialogModalPlans" :open-dialog.sync="dialogModalPlans" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ModalPlans from "@/components/modals/Plans";

export default {
  name: "PlanOptions",
  components: { ModalPlans },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    dialogModalPlans: false,
  }),
  computed: {
    ...mapGetters(["getSubscription", "getPlans", "getQuotas"]),
    getPercentage() {
      return this.getQuotas ? (this.getQuotas.orders_amount * 100) / this.getQuotas.orders_amount_max : 0;
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions(["getAccountQuotas"]),
    async init() {
      await this.getAccountQuotas();
    },
  },
};
</script>
